import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Re-visits the current page after `interval` ms — used while an import is
// pending/processing so the status banner updates itself.
export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.timer = setTimeout(
      () => Turbo.visit(window.location.href, { action: "replace" }),
      this.intervalValue
    )
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
